var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _path, _path2, _path3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _polygon, _path4, _path5, _path6, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _polygon2, _path7, _path8, _path9, _polygon3, _circle22, _circle23, _circle24, _circle25, _circle26, _path10, _path11, _path12, _path13, _circle27, _path14, _path15, _path16, _ellipse, _ellipse2, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b7790654-0e28-4738-83df-b9467b840980",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1078.27588,
    height: 730.4165,
    viewBox: "0 0 1078.27588 730.4165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "smart_resize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.19873,
    y: 361.93604,
    width: 190.61279,
    height: 2,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 359.14014,
    y: 361.93604,
    width: 190.6123,
    height: 2,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 797.37158,
    y: 361.93604,
    width: 190.6123,
    height: 2,
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.90391,
    cy: 362.93641,
    r: 11.57928,
    fill: "#38a7ba"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.44641,
    cy: 362.93641,
    r: 11.57928,
    fill: "#38a7ba"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 969.27884,
    cy: 362.93641,
    r: 11.57928,
    fill: "#38a7ba"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.01434,251.9205c12.78381,38.47364,8.29413,74.598,8.29413,74.598s-25.21633-26.25378-38.00014-64.72742-8.29413-74.598-8.29413-74.598S494.23053,213.44685,507.01434,251.9205Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#38a7ba"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M523.6026,251.9205c-12.78381,38.47364-8.29413,74.598-8.29413,74.598s25.21634-26.25378,38.00015-64.72742,8.29412-74.598,8.29412-74.598S536.38641,213.44685,523.6026,251.9205Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#38a7ba"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M528.75144,252.33654c.85689,40.53286-14.09644,73.722-14.09644,73.722s-16.34263-32.52757-17.19953-73.06043,14.09644-73.72206,14.09644-73.72206S527.89454,211.80367,528.75144,252.33654Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.2414,
    cy: 131.72289,
    r: 3.96798,
    fill: "#38a7ba"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.52588,
    cy: 163.46673,
    r: 2.20443,
    fill: "#38a7ba"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.63179,
    cy: 141.64284,
    r: 2.20443,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 495.4483,
    cy: 120.25983,
    r: 2.20443,
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.09484,
    cy: 162.36451,
    r: 2.20443,
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.38795,
    cy: 149.5788,
    r: 2.20443,
    fill: "#3f3d56"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.4175,
    cy: 194.76969,
    r: 2.20443,
    fill: "#3f3d56"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.59238,
    cy: 182.20442,
    r: 2.20443,
    fill: "#3f3d56"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 456.20938,
    cy: 184.40885,
    r: 2.20443,
    fill: "#38a7ba"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "468.178 266.779 467.672 264.843 585.942 233.953 536.733 45.548 322.95 101.386 359.42 241.014 357.484 241.52 320.51 99.956 538.163 43.107 538.416 44.075 588.383 235.382 468.178 266.779",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M942.01682,256.61479c17.76006,53.45,11.52271,103.63612,11.52271,103.63612s-35.03208-36.47337-52.79214-89.92334-11.52272-103.63612-11.52272-103.63612S924.25676,203.16482,942.01682,256.61479Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#38a7ba"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M965.06225,256.61479c-17.76006,53.45-11.52272,103.63612-11.52272,103.63612s35.03209-36.47337,52.79215-89.92334,11.52271-103.63612,11.52271-103.63612S982.8223,203.16482,965.06225,256.61479Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#38a7ba"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M972.21533,257.19278C973.40579,313.50354,952.6317,359.612,952.6317,359.612S929.9275,314.4227,928.73705,258.112s19.58363-102.41923,19.58363-102.41923S971.02488,200.882,972.21533,257.19278Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#3f3d56"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 889.61413,
    cy: 122.63503,
    r: 5.51256,
    fill: "#38a7ba"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 878.89526,
    cy: 166.73554,
    r: 3.06254,
    fill: "#38a7ba"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 841.53232,
    cy: 136.41644,
    r: 3.06254,
    fill: "#3f3d56"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 949.63982,
    cy: 106.70985,
    r: 3.06254,
    fill: "#3f3d56"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 857.45751,
    cy: 165.20428,
    r: 3.06254,
    fill: "#3f3d56"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 921.77075,
    cy: 147.44157,
    r: 3.06254,
    fill: "#3f3d56"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 859.29503,
    cy: 210.22355,
    r: 3.06254,
    fill: "#3f3d56"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 924.83329,
    cy: 192.76709,
    r: 3.06254,
    fill: "#3f3d56"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 895.12669,
    cy: 195.82963,
    r: 3.06254,
    fill: "#38a7ba"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "911.656 309.886 911.15 307.951 1075.834 264.937 1007.274 2.44 709.52 80.211 760.285 274.567 758.349 275.073 707.079 78.781 1008.704 0 1008.957 0.967 1078.276 266.367 911.656 309.886",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.28561,296.30045a93.22214,93.22214,0,0,1,4.08173,36.7113,88.568,88.568,0,0,1-22.78243-68.56508A93.22216,93.22216,0,0,1,160.28561,296.30045Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#38a7ba"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.44906,296.30045a93.222,93.222,0,0,0-4.08172,36.7113,88.56807,88.56807,0,0,0,22.78242-68.56508A93.22216,93.22216,0,0,0,168.44906,296.30045Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#38a7ba"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M170.98291,296.50519a93.22219,93.22219,0,0,1-6.93716,36.28024,88.568,88.568,0,0,1-1.5271-72.23487A93.222,93.222,0,0,1,170.98291,296.50519Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "114.146 272.979 113.64 271.043 204.57 247.293 166.76 102.534 2.44 145.452 30.49 252.842 28.554 253.348 0 144.022 168.19 100.093 207.01 248.723 114.146 272.979",
    fill: "#3f3d56"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 922.07102,
    cy: 87.70593,
    r: 13.3607,
    fill: "#38a7ba"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 860.61179,
    cy: 94.83164,
    r: 7.12571,
    fill: "#3f3d56"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.50528,
    cy: 410.4165,
    r: 19,
    fill: "#3f3d56"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.44641,
    cy: 410.4165,
    r: 19,
    fill: "#3f3d56"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 892.67747,
    cy: 410.4165,
    r: 19,
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M714.68066,815.20825H713.75c-48.1958,0-93.93945-2.39648-128.8042-6.748l-1.40625-.18458q-1.43041-.1875-2.82568-.37695c-5.47217-.72168-10.82764-1.53125-15.91309-2.40527-25.24951-4.39649-38.05078-9.63672-38.05078-15.5752,0-4.92578,8.39648-9.21972,25.66943-13.126,8.31055-1.87793,18.56983-3.60938,30.49268-5.14649,2.17187-.29,4.4082-.56054,6.69482-.82031,34.15235-3.99609,78.2417-6.19727,124.14307-6.19727,9.07324,0,18.25488.08789,27.28906.25977C817.96045,766.36255,900.75,774.82349,900.75,789.91821c0,9.01563-29.93408,14.834-55.0459,18.12793C810.74756,812.63013,764.21582,815.17407,714.68066,815.20825ZM713.75,766.62817c-45.82617,0-89.833,2.19629-123.91357,6.1836q-3.41529.38964-6.66407.81738c-11.86572,1.5293-22.0625,3.249-30.31152,5.11426-21.76172,4.9209-24.11084,9.4541-24.11084,11.1748,0,2.18555,3.5459,7.88575,36.3916,13.6045,5.05762.86914,10.38721,1.6748,15.83936,2.39453.93017.12793,1.86914.251,2.81836.375l1.40185.18457c34.77783,4.34082,80.43311,6.73144,128.54883,6.73144h.93018c110.106-.07617,184.06982-12.10351,184.06982-23.29,0-9.835-59.00586-21.13867-157.749-23.03027C731.97949,766.71509,722.81055,766.62817,713.75,766.62817Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M623.4873,768.67407l-1.07324-.40234c-.23584-.08887-23.70849-9.082-34.7041-29.47363-10.99609-20.39258-5.61182-44.94532-5.55615-45.19043l.25342-1.11817,1.07275.40235c.23584.08886,23.708,9.082,34.7041,29.47363,10.9961,20.39258,5.61182,44.94531,5.55615,45.19043Zm-34.0166-30.82519c9.29639,17.24121,27.84522,26.0791,32.54493,28.09668.89355-5.03711,3.6958-25.40625-5.59229-42.63086-9.28711-17.22266-27.84326-26.07422-32.54492-28.09668C582.98438,700.25806,580.18311,720.62524,589.4707,737.84888Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M596.11315,731.64505c19.76057,11.88861,27.371,35.50267,27.371,35.50267s-24.42779,4.33881-44.18836-7.5498-27.371-35.50267-27.371-35.50267S576.35258,719.75644,596.11315,731.64505Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#38a7ba"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M749.85076,347.25641s-16.544-2.36343-24.816,28.36116-10.63543,33.088-10.63543,33.088,48.45031,7.09029,49.632,4.72686S774.66677,354.3467,749.85076,347.25641Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#2f2e41"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 679.53498,
    cy: 218.74121,
    r: 31.9063,
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M726.21646,329.53069s10.63543,27.17944,7.09029,30.72459,43.72345,8.272,43.72345,8.272,3.54515-17.72572-10.63543-28.36116c0,0-5.90858-17.72572-4.72686-21.27087S726.21646,329.53069,726.21646,329.53069Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M754.57762,341.34784a85.21588,85.21588,0,0,0-31.9063,21.27087c-14.18058,15.36229-21.27087,20.08915-21.27087,20.08915s-16.544,5.90857-10.63544,34.26973c2.95429,14.18058.88629,30.13373-1.92028,42.54174a265.8223,265.8223,0,0,0-6.35172,58.65559v12.2473S573.77524,758.4932,610.4084,773.8555s69.72118,20.08915,72.08461,16.544,44.90516-187.89267,44.90516-187.89267,11.81715,197.34639,41.36,197.34639,77.99318-8.272,77.99318-8.272l-60.26746-236.343s14.18058-40.17831-21.27087-68.53947l-4.72686-12.99886c19.60447.01,28.56614-124.06968,8.272-134.7155C768.7582,338.98441,764.03134,335.43926,754.57762,341.34784Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M725.03474,405.16044l-16.544,43.72345-38.9966,81.53833s-17.72572,53.17717-3.54514,53.17717,24.816-50.81374,24.816-50.81374l43.72345-68.53946,24.816-61.44918Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#ffb8b8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 585.58864,
    cy: 703.24433,
    rx: 20.68001,
    ry: 11.81715,
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 743.93844,
    cy: 703.24433,
    rx: 20.68001,
    ry: 11.81715,
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M752.71423,258.79028h-.00012a25.34137,25.34137,0,0,0-4.89258.48651,21.44172,21.44172,0,0,0-9.34021-2.15271h-.84778c-16.34472,0-29.5946,14.7901-29.5946,33.03461v.00006h5.47669l.88452-6.73224,1.29675,6.73224h4.56226a64.57589,64.57589,0,0,0-2.119,16.55036V340.333h8.28027l4.794-12.45795L730.01587,340.333H783.239l4.35816-11.32538-1.0896,11.32538H792.5V313.93219C792.5,283.47821,774.68726,258.79028,752.71423,258.79028Z",
    transform: "translate(-60.86206 -84.79175)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg12);
export default __webpack_public_path__ + "static/media/svg-12.f1eb174361b7cea5ac42a1a9cccf8ab7.svg";
export { ForwardRef as ReactComponent };